<template>
  <div class="card-container">
    <div class="card-content">
      <div class="relative">
        <h4>
          Try our
          <span class="relative"
            >Enterprise

            <img
              src="../../assets/pricing-card-underline.svg"
              class="absolute -bottom-2 left-0 w-full"
            />
          </span>
          Plan today!
        </h4>
      </div>
      <ul class="plans">
        <li v-for="plan in plans" :key="plan">
          {{ plan }}
        </li>
      </ul>
      <button
        @click="$router.push('/manage-billing')"
        class="whitebutton-gemnote button-gemnote-glass--tiny"
      >
        <span>Upgrade</span>
      </button>
    </div>
    <div class="card-image">
      <img
        src="../../assets/pricing-card-img.png"
        class="w-full h-full object-cover md:object-fill"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderStats',
  data() {
    return {
      plans: [
        'Up to 75 sends/mo',
        'Inventory 1000 items',
        'International shipping',
        'Custom kitting'
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.whitebutton-gemnote--small {
  font-size: 0.813rem;
  font-weight: normal;
  height: 2.5rem;
  width: max-content !important;
  padding: 0 0rem !important;
  background-color: #232220 !important;
}

.button-gemnote-glass--tiny {
  width: max-content !important;
  font-weight: 400 !important;
  padding: 0 1rem !important;
  background-color: #232220 !important;
  color: #dfdad2 !important;
}

.card-container {
  display: grid;
  grid-template-columns: 57% 43%;
  background-color: #dfdad2;
  border-radius: 6px;
  border: 0.5px solid #232220;

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    border-right: 0.5px solid #232220;
    padding: 1rem;
    padding-left: 1.5rem;
    h4 {
      text-align: left;
      font-size: 1rem;
      font-family: $editorial;
      font-weight: normal;
      color: #232220;
    }
    p {
      color: #f5f2ee;
      font-size: 0.568rem;
      text-align: left;
      margin: 1rem 0;
      font-weight: 300;
    }

    .plans {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      list-style-type: disc;
      margin: 1rem 0;
      gap: 0.75rem;

      li {
        color: #f5f2ee;
        font-size: 0.568rem;
        text-align: left;
        font-weight: 500;
        color: #232220;
        line-height: 10px !important;
        margin-left: 0.3rem;
      }
    }
  }
  .card-image {
    padding: 0.4rem;
  }
}

@media (max-width: 854px) {
  .card-container {
    .card-content {
      padding-left: 1rem;
    }
  }
}
@media (min-width: 2100px) {
  .card-container {
    .card-content {
      gap: 1rem;
    }
  }
}
</style>
